import styles from './VilleCCASHeader.module.css'

import { SvgOfficialLogoCCASandVille } from '../../../svg/SvgComponents'

const VilleCCASHeader = () => (
  <>
    <header className={styles.header}>
      <div className={styles.logo}>
        <SvgOfficialLogoCCASandVille />
      </div>
    </header>
  </>
)

export default VilleCCASHeader
